import ApiClient from "./ApiClient";

export const updateProfile = ({ body, token, userId }) => {
  return ApiClient.post('/api/users/update_profile/' + userId, body, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export const updatePassword = async ({ token, userId, currentPassword, newPassword }) => {
  return await ApiClient.put('/api/users/'+ userId +'/update_password', {
    current_password: currentPassword,
    new_password: newPassword
  }, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const fetchAllUsers = ({ token }) => {
    return ApiClient.get('/api/users', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export const fetchUser = ({ token, userId }) => {
    return ApiClient.get('/api/users/' + userId, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export const resetPassword = async ({ token, userId }) => {
    return await ApiClient.put('/api/users/' + userId + '/reset_password', null, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const updateUser = ({ token, userId, user }) => {
    return ApiClient.put('/api/users/' + userId + '/update_by_admin', user, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const deleteUser = ({ token, userId }) => {
    return ApiClient.delete('/api/users/' + userId, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}